import {UserContext, UserProvider, UserProviderProps} from "./User.tsx";
import React from "react";
/**
 * UserProviderChecker conditionally wraps children with UserProvider only if
 * a UserContext doesn't already exist in the component tree.
 *
 * Use this in embeddable apps that might be nested within a parent app that
 * already provides UserContext (e.g., map embedded in site).
 */
export const UserProviderChecker: React.FC<UserProviderProps> = ({children, partnerKey}) => {
    // Check if we're already inside a UserProvider by accessing the context
    const existingContext = React.useContext(UserContext);

    // If context exists, we're already wrapped - just render children
    if (existingContext !== undefined) {
        return <>{children}</>;
    }

    // If no context exists, wrap with UserProvider
    return (
        <UserProvider partnerKey={partnerKey}>
            {children}
        </UserProvider>
    );
};